import React from 'react'

const CardContent = ({ children }: { children: React.ReactNode }) => (
  <div className="w-full p-3 flex flex-col space-y-2">{children}</div>
)

export default CardContent
